"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.InvalidatableTimeout = exports.timeout = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

/**
 * This method can be called in ES7 style as replacement for setTimeout <b>if you do not need to invalidate the timer</b>.<br/>
 * If you need an invalidatable timer use InvalidatableTimer instead!
 *
 * Comparison:
 *
 * Old code <pre>
 *    let a = 42;
 *    setTimeout(() => {
 *      a += 1;
 *    }, 1000); </pre>
 *
 * With Promise: <pre>
 *    let a = 42;
 *    await timeout(1000);
 *    a += 1; </pre>
 *
 * @param ms The duration to wait in milliseconds
 * @returns {Promise}
 */
var timeout = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var ms,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ms = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
            return _context.abrupt("return", new _promise["default"](function (resolve) {
              return setTimeout(resolve, ms);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function timeout() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * This method can be called in ES7 style as replacement for setTimeout <b>if you need to invalidate the timer</b>.<br/>
 * If you don't need an invalidatable timer use the function 'timeout' which returns a Promise instead!
 *
 * Comparison:
 *
 * Old code <pre>
 *    let a = 42;
 *    let id = setTimeout(() => {
 *      a += 1;
 *    }, 1000);
 *    clearTimeout(id);
 *    </pre>
 *
 * With Promise: <pre>
 *    let a = 42;
 *    const timeout = new InvalidatableTimeout(1000);
 *    await timeout.wait();
 *    a += 1; </pre>
 *
 *    // and somewhere else with the same timeout object during the wait time
 *    timeout.invalidate();
 *
 *    // or restart it (same as timeout.invalidate() followed by timeout.wait())
 *    await time.restart();
 *
 * @param ms The duration to wait in milliseconds
 * @returns {Promise}
 */


exports.timeout = timeout;

var InvalidatableTimeout = function InvalidatableTimeout() {
  var _this = this;

  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  (0, _classCallCheck2["default"])(this, InvalidatableTimeout);
  (0, _defineProperty2["default"])(this, "invalidate", function () {
    console.log('INVALIDATE timer in TimeoutHelper', _this.timeoutId);

    if (_this.timeoutId !== null) {
      console.log('INVALIDATE timer in TimeoutHelper (really)', _this.timeoutId);
      clearTimeout(_this.timeoutId);

      if (_this.promiseReject) {
        console.log('INVALIDATE timer in TimeoutHelper (call reject)');

        _this.promiseReject();

        _this.promiseReject = null;
      }
    }
  });
  (0, _defineProperty2["default"])(this, "restart", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _this.invalidate();

            return _context2.abrupt("return", _this.wait());

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  (0, _defineProperty2["default"])(this, "wait", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
              _this.promiseReject = reject;
              _this.timeoutId = setTimeout(function () {
                _this.promiseReject = null;
                resolve();
              }, _this.ms);
              console.log('TIMEOUT HELPER timeoutID = ', _this.timeoutId);
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));
  this.ms = ms;
  this.timeoutId = null;
  this.promiseReject = null;
}
/**
 * Invalidates the timer, neither leads to calling resolve nor reject on old promise
 */
;

exports.InvalidatableTimeout = InvalidatableTimeout;